import React, { useEffect, useState } from "react";
import { FaCheck } from "react-icons/fa";

import { getSharedConsumer } from "../../channels/consumer";
const ElementContainer = (props) => {
  const {
    id,
    user,
    completed,
    requirable,
    reviewable,
    color,
    title,
    status,
    icon,
    token,
  } = props;

  const [hasCompleted, setCompleted] = useState(false);
  const [currentStatus, setCurrentStatus] = useState(status);
  const isP3G = (compare) => {
    const p3g_games = [
      "Play Acceleration City!",
      "Play Super Slime Battle!",
      "Play Zillah City: Fall of the Toxibots",
      "Play Zillah Beats",
      "Play Ghosts of the USS Salazar",
    ];
    if (p3g_games.includes(compare)) {
      return true;
    }
  };

  useEffect(() => {
    if (!requirable) {
      return undefined;
    }

    setCompleted(completed);
    setCurrentStatus(status);

    if (isP3G(title) || !user || !token) {
      return undefined;
    }

    const sub = getSharedConsumer(token).subscriptions.create(
      { channel: "UserRequirementChannel", id: user.id },
      {
        initialized() {},
        connected() {},
        disconnected() {
          console.warn(
            user.id,
            ": Client disconnected from User Requirement Channel"
          );
        },
        rejected() {
          console.warn(
            user.id,
            ": Client rejected from User Requirement Channel"
          );
        },
        received(data) {
          if (data.element_id != id) {
            return;
          }

          var element = document.getElementById(
            `requirement_${data.type}_${data.element_id}`
          );
          if (data.status !== undefined) {
            setCurrentStatus(data.status);
          }

          const broadcastCompleted =
            data.completed !== undefined
              ? data.completed
              : reviewable
                ? data.status === "completed"
                : true;

          if (element && broadcastCompleted) {
            element.style.color = "limegreen";
            element.style.padding = "5px";
          }
          setCompleted(broadcastCompleted);
        },
      }
    );

    return () => {
      sub.unsubscribe();
    };
  }, []);

  const borderLine = {
    borderBottom: "1px solid black",
    borderColor: color,
    paddingBottom: "1em",
  };

  return (
    <div className="f-col-s12 padless m-bottom-2 element-complex">
      <div
        className="f-col-s12 p-left-0 p-right-0 p-top-0 flex f-d-row m-bottom-1"
        style={borderLine}
      >
        <span className="flex f-a-self-center">
          {icon && !requirable ? (
            <i className={`bx ${icon} icon-medium`} />
          ) : null}
          {requirable ? (
            <RequirementStatus completed={hasCompleted} icon={icon} />
          ) : null}
        </span>

        <div className="flex f-d-column expand">
          <h2 className="marginless">{title}</h2>
          {reviewable ? <ReviewableStatus status={currentStatus} /> : null}
        </div>
      </div>

      {props.children}

      <div className="clearfix" />
    </div>
  );
};

const RequirementStatus = (props) => {
  const completed = props.completed;
  const icon = props.icon;
  const iconStatus = {
    backgroundColor: completed ? "limegreen" : "none",
    display: "flex",
    margin: completed ? "0 5px 0 0" : "0",
    padding: "5px",
    borderRadius: 5,
  };

  const checkColor = {
    color: "white",
    paddingLeft: 5,
  };

  return (
    <span style={iconStatus}>
      <i
        className={completed ? `bx ${icon}` : `bx ${icon} icon-medium`}
        style={completed ? { color: "white" } : { color: "gray" }}
      />
      {completed ? <FaCheck style={checkColor} /> : null}
    </span>
  );
};

const ReviewableStatus = (props) => {
  const { status } = props;
  const fontSize = {
    fontSize: ".9em",
    padding: "2px 4px",
  };

  switch (status) {
    case "incomplete":
      return (
        <div className="f-col-s12 padless">
          <div
            className="f-col-s12 secondary font-size-half radius"
            style={fontSize}
          >
            <i className="bx bxs-error-circle primary-text m-right-half" />
            This upload must be verified. Upload to continue..
          </div>
        </div>
      );

    case "submitted":
      return (
        <div className="f-col-s12 padless">
          <div
            className="f-col-s4 radius p-right-0 primary font-size-half"
            style={fontSize}
          >
            <i className="bx bx-check-circle secondary-text m-right-half" />
            Uploaded
          </div>
          <div
            className="f-col-s8 radius-right p-left-0 secondary font-size-half"
            style={fontSize}
          >
            <i className="bx bxs-error-circle primary-text m-right-half" />
            Awaiting verifications..
          </div>
        </div>
      );

    case "rejected":
      return (
        <div className="f-col-s12 padless">
          <div
            className="f-col-s4 radius-left p-right-0 primary font-size-half"
            style={fontSize}
          >
            <i className="bx bx-check-circle secondary-text m-right-half" />
            Uploaded
          </div>
          <div
            className="f-col-s4 radius-right p-right-0 p-left-0 primary font-size-half"
            style={fontSize}
          >
            <i className="bx bx-check-circle secondary-text m-right-half" />
            Verified
          </div>
          <div
            className="f-col-s4 radius-right p-left-0 secondary font-size-half"
            style={fontSize}
          >
            <i className="bx bxs-x-circle danger-text m-right-half" />
            Rejected..
          </div>
        </div>
      );

    case "completed":
      return (
        <div className="f-col-s12 padless">
          <div
            className="f-col-s4 radius-left p-right-0 primary font-size-half"
            style={fontSize}
          >
            <i className="bx bx-check-circle secondary-text m-right-half" />
            Uploaded
          </div>
          <div
            className="f-col-s4 p-right-0 p-left-0 primary font-size-half"
            style={fontSize}
          >
            <i className="bx bx-check-circle secondary-text m-right-half" />
            Verified
          </div>
          <div
            className="f-col-s4 radius-right p-left-0 primary font-size-half"
            style={fontSize}
          >
            <i className="bx bx-check-circle secondary-text m-right-half" />
            Accepted
          </div>
        </div>
      );
  }

  return <div></div>;
};

export default ElementContainer;
